import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    h: "1. Information We Collect",
    p: "We collect the information you provide when joining the waitlist or creating a profile, including your email address, answers to compatibility questions, and verification details.",
  },
  {
    h: "2. How We Use Your Data",
    p: "Your data is used to match you with compatible members, verify identity, improve the service, and send you relevant updates such as your waitlist confirmation.",
  },
  {
    h: "3. Progressive Reveal & Photos",
    p: "Photos are stored securely and revealed progressively as connections deepen. We never sell your photos or personal data to third parties.",
  },
  {
    h: "4. Data Sharing",
    p: "We share data only with trusted providers needed to operate Reveal (such as email delivery) and only to the extent necessary. We do not sell your personal information.",
  },
  {
    h: "5. Your Rights",
    p: "You may request access to, correction of, or deletion of your personal data at any time by contacting us. You can unsubscribe from emails at any point.",
  },
  {
    h: "6. Contact",
    p: "For any privacy questions or requests, reach out to our team and we'll respond as soon as possible.",
  },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-reveal-black text-reveal-cream font-body px-5 py-16" data-testid="privacy-page">
      <div className="max-w-2xl mx-auto">
        <Link
          to="/landing"
          data-testid="privacy-back-link"
          className="inline-flex items-center gap-2 text-sm text-reveal-rose hover:text-reveal-cream transition-colors mb-10"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Reveal
        </Link>
        <h1 className="font-heading text-4xl sm:text-5xl text-reveal-cream mb-3">Privacy Policy</h1>
        <p className="text-sm text-reveal-cream/45 mb-12">Last updated: June 2026</p>
        <div className="space-y-9">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-heading text-2xl text-reveal-rose mb-2">{s.h}</h2>
              <p className="text-reveal-cream/70 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
        <p className="mt-14 text-sm text-reveal-cream/45">
          Questions? Reach us at{" "}
          <a href="mailto:hello@getrevealapp.com" className="text-reveal-rose hover:text-reveal-cream transition-colors">
            hello@getrevealapp.com
          </a>
        </p>
      </div>
    </div>
  );
}
